import { INTERACTION_TYPES } from '@vfmfe/foundations';

export const mapNodeType = (nodeType: string) => {
    switch (nodeType.toUpperCase()) {
        case 'INDIVIDUAL':
            return INTERACTION_TYPES.INDIVIDUAL;
        case 'BILLINGACCOUNT':
        case 'BILLING_ACCOUNT':
            return INTERACTION_TYPES.BILLING_ACCOUNT;
        case 'PRODUCT':
            return INTERACTION_TYPES.PRODUCT;
        case 'ACCESS':
            return INTERACTION_TYPES.ACCESS;
        case 'SERVICE':
            return INTERACTION_TYPES.PRODUCT;
        default:
            return undefined;
    }
};
